// نوار اطلاعیه‌های پلتفرم (US-PLT-082): اطلاعیه‌های فعال منطبق بر کاربر (مخاطب، نقش و بازه را سرور اعمال می‌کند) تا تأیید
// مشاهده («متوجه شدم» ← ثبت ack — AC-PLT-082.1). شکست دریافت پوسته را مختل نمی‌کند.
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { unwrap, type AnnouncementSeverity } from '@phoenix/api-client';
import { useTenantSession } from '@phoenix/auth';
import { useTranslation } from '@phoenix/i18n';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { pltKeys } from '../pages/settings/common';

function severityOf(severity: AnnouncementSeverity): 'info' | 'warning' | 'error' {
  return severity === 'Critical' ? 'error' : severity === 'Warning' ? 'warning' : 'info';
}

export function AnnouncementBanner() {
  const { t } = useTranslation('plt');
  const { tenantApi, session } = useTenantSession();
  const queryClient = useQueryClient();
  const announcements = useQuery({
    queryKey: pltKeys.announcements(session?.tenantId),
    queryFn: () => unwrap(tenantApi.GET('/api/v1/platform/announcements/active')),
    enabled: Boolean(session?.tenantId),
    staleTime: 5 * 60_000,
    retry: false,
  });
  const ack = useMutation({
    mutationFn: (id: string) =>
      unwrap(tenantApi.POST('/api/v1/platform/announcements/{id}:ack', { params: { path: { id } } })),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: pltKeys.announcements(session?.tenantId) }),
  });

  const pending = (announcements.data?.items ?? []).filter((item) => !item.acknowledged);
  if (pending.length === 0) {
    return null;
  }
  return (
    <Stack spacing={1} sx={{ mb: 1 }} data-testid="announcements">
      {pending.map((item) => (
        <Alert
          key={item.id}
          severity={severityOf(item.severity)}
          data-testid={`announcement-${item.id}`}
          action={
            <Button
              color="inherit"
              size="small"
              onClick={() => ack.mutate(item.id)}
              disabled={ack.isPending}
              data-testid={`announcement-ack-${item.id}`}
            >
              {t('plt:announcements.ack')}
            </Button>
          }
        >
          <AlertTitle>{item.title}</AlertTitle>
          {item.body}
        </Alert>
      ))}
    </Stack>
  );
}
